var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 2.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893C8.06759 0.653377 8.09532 1.22061 7.7903 1.6129L7.70711 1.70711L7.38916 2.02302C7.59161 2.00771 7.79532 2 8 2C12.4183 2 16 5.58172 16 10C16 14.4183 12.4183 18 8 18C3.58172 18 0 14.4183 0 10C0 9.44771 0.447715 9 1 9C1.55228 9 2 9.44771 2 10C2 13.3137 4.68629 16 8 16C11.3137 16 14 13.3137 14 10C14 6.68629 11.3137 4 8 4C7.81293 4 7.62712 4.00853 7.44295 4.02545L7.70711 4.29289C8.09763 4.68342 8.09763 5.31658 7.70711 5.70711C7.34662 6.06759 6.77939 6.09532 6.3871 5.7903L6.29289 5.70711L4.29289 3.70711C3.93241 3.34662 3.90468 2.77939 4.2097 2.3871L4.29289 2.29289L6.29289 0.292893L4.29289 2.29289Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.d6935674a01c86960db798dd42be98c7.svg";
export { ForwardRef as ReactComponent };